export const providerLabels: Record<string, string> = {
  'gateway-whatsapp': 'WhatsApp',
  'whatsapp-business': 'WhatsApp Business',
  'instagram-messaging': 'Instagram',
  'facebook-messenger': 'Facebook',
  'telegram-bot': 'Telegram',
  'email-smtp': 'Email (SMTP)',
  'email-sendgrid': 'Email (SendGrid)',
  'email-ses': 'Email (SES)',
  'email-resend': 'Email (Resend)',
  'gmail-api': 'Gmail',
  'sms-twilio': 'SMS',
  'website-widget': 'Widget',
  'website-chat': 'Chat',
};

export const formatProviderLabel = (id: string) => providerLabels[id] || id;

export const channelStatusLabels: Record<string, string> = {
  active: 'Conectado',
  inactive: 'Desconectado',
  pending: 'Aguardando',
  suspended: 'Suspenso',
  error: 'Erro',
};
